import type { ValidationOverride } from '@festina/life-general-types/life'
import { notEmpty, type Optional } from '@festina-life/core'
import { IconButton } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import {
  Table,
  TBody,
  Td,
  Th,
  THead,
  Tr,
} from '@festina-life/ui/listsAndTables'

type Props = {
  validationOverrides: Optional<(ValidationOverride | null)[]>
  onDeleteValidationOverride?: (validationOverrideKey: Optional<string>) => void
}

export function ValidationOverridesTable({
  validationOverrides,
  onDeleteValidationOverride,
}: Props) {
  const translate = useTranslate()

  return validationOverrides?.length ? (
    <>
      <h3>{translate('validationOverridesInEffect.title')}</h3>
      <Table>
        <THead>
          <Tr>
            <Th>{translate('validationOverridesInEffect.key')}</Th>
            <Th>{translate('validationOverridesInEffect.reason')}</Th>
            {onDeleteValidationOverride && <Th />}
          </Tr>
        </THead>
        {validationOverrides.filter(notEmpty).map((override) => (
          <TBody key={override.validationOverrideKey}>
            <Tr>
              <Td>{override.validationOverrideKey}</Td>
              <Td>{override.reason}</Td>
              {onDeleteValidationOverride && (
                <Td>
                  <IconButton
                    onClick={() =>
                      onDeleteValidationOverride(override.validationOverrideKey)
                    }
                    iconName="Trash"
                  />
                </Td>
              )}
            </Tr>
          </TBody>
        ))}
      </Table>
    </>
  ) : null
}
